import type { ComponentProps, ReactNode } from 'react';
import classnames from 'classnames/bind';
import { isNil } from 'lodash/fp';
import { useModalContext } from 'app/components/core/Modal/ModalContext';
import * as styles from './ModalBody.css';

const cx = classnames.bind(styles);

interface ModalBodyProps extends ComponentProps<'div'> {
    testId?: string;
    children?: ReactNode;
}

export function ModalBody({ testId, className, children, ...props }: ModalBodyProps) {
    const context = useModalContext();

    if (isNil(context)) {
        throw new Error('<ModalBody> must be used within a <Modal> component.');
    }

    const classes = cx('base', className);

    return (
        <div tabIndex={-1} data-testid={testId} className={classes} {...props}>
            {children}
        </div>
    );
}
